import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { FormModalControlled } from "../../components/Modal";
import Input from "../../components/Input";
import Label from "../../components/Label";
import { setColorMapping, selectColorMappings } from "./configurationsSlice";

const AVAILABLE_ELEMENTS = [
  { id: "korpusas", label: "Korpusas" },
  { id: "stalčius", label: "Stalčius" },
];

const ColorElementRow = ({
  element,
  colorPreview,
  onColorFileChange,
}) => {
  const fileInputRef = useRef(null);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "var(--gap-sm)",
      }}
    >
      <div style={{ width: "var(--width-20)", flexShrink: 0 }}>
        <Label>{element.label}</Label>
      </div>
      <div
        onClick={() => fileInputRef.current?.click()}
        style={{
          width: "40px",
          height: "40px",
          flexShrink: 0,
          borderRadius: "var(--rounded)",
          border: "1px dashed var(--clr-grey-300)",
          cursor: "pointer",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: colorPreview
            ? `url(${colorPreview}) center/cover`
            : "var(--clr-grey-100)",
        }}
        title="Pasirinkti spalvos failą"
      >
        {!colorPreview && (
          <span style={{ fontSize: "18px", opacity: 0.4 }}>+</span>
        )}
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) onColorFileChange(f);
        }}
      />
    </div>
  );
};

const ColorMappingModal = ({ isOpen, onClose, colorLabel }) => {
  const dispatch = useDispatch();
  const { configurationId } = useParams();
  const colorMappings = useSelector(selectColorMappings(configurationId));
  const existingMapping = colorLabel ? colorMappings[colorLabel] : null;

  const [checkedElements, setCheckedElements] = useState({});
  const [colorPreviews, setColorPreviews] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [colorFiles, setColorFiles] = useState({});

  useEffect(() => {
    if (isOpen && existingMapping) {
      const checked = {};
      existingMapping.forEach((id) => {
        checked[id] = true;
      });
      setCheckedElements(checked);
    } else if (!isOpen) {
      setCheckedElements({});
      setColorPreviews({});
      setColorFiles({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const activeElements = AVAILABLE_ELEMENTS.filter(
    (el) => checkedElements[el.id],
  );

  const handleToggleElement = (elementId) => {
    setCheckedElements((prev) => ({ ...prev, [elementId]: !prev[elementId] }));
  };

  const handleColorFileChange = (elementId, file) => {
    if (colorPreviews[elementId]) {
      try {
        URL.revokeObjectURL(colorPreviews[elementId]);
      } catch (_) {}
    }
    const url = URL.createObjectURL(file);
    setColorFiles((prev) => ({ ...prev, [elementId]: file }));
    setColorPreviews((prev) => ({ ...prev, [elementId]: url }));
  };

  const handleSubmit = () => {
    const elementIds = activeElements.map((el) => el.id);
    dispatch(
      setColorMapping({
        configurationId,
        colorLabel,
        elementIds,
      }),
    );
    onClose?.();
  };

  return (
    <FormModalControlled
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={handleSubmit}
      submitLabel="Gerai"
      cancelLabel="Atšaukti"
    >
      <h2>Spalvų žemėlapis</h2>
      <p style={{ margin: 0, opacity: 0.8 }}>{colorLabel}</p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap-sm)",
          margin: "var(--gap) 0",
          minWidth: "min(400px, 80vw)",
        }}
      >
        <Label>Elementai</Label>
        {AVAILABLE_ELEMENTS.map((el) => (
          <Input
            key={el.id}
            type="checkbox"
            label={el.label}
            name={`mapping_${el.id}`}
            value={!!checkedElements[el.id]}
            onChange={() => handleToggleElement(el.id)}
          />
        ))}
      </div>

      {activeElements.length > 0 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "var(--gap-sm)",
            marginBottom: "var(--gap)",
          }}
        >
          <Label>Tekstūros</Label>
          {activeElements.map((el) => (
            <ColorElementRow
              key={el.id}
              element={el}
              colorPreview={colorPreviews[el.id] || null}
              onColorFileChange={(f) => handleColorFileChange(el.id, f)}
            />
          ))}
        </div>
      )}
    </FormModalControlled>
  );
};

export default ColorMappingModal;
